<template>
    <div>
        <img
            v-show="layer.serviceType !== owsTypeConst.WMTS"
            :ref="`layer_${layer.id}`"
            :src="layer.legendImageURL"
            :alt="$t('legendImageAlt', [layer.title])"
            class="pt-1 pb-2 pr-1"
            @error="$_imgNotFound(layer.id)"
        />
    </div>
</template>

<script>
    import { OWS_TYPE } from './../../../../constants';

    export default {
        name: 'legend-style-graphic',

        data() {
            return { owsTypeConst: OWS_TYPE };
        },

        props: { layer: { type: Object, required: true } },
        mounted() {
            if (!this.layer.legendImageURL) {
                this.$_imgNotFound(this.layer.id);
            }
        },
        methods: {
            /**
             * Hide image if an error occurs when loading the image
             * @param id int - id of layer
             */
            $_imgNotFound(id) {
                const img = this.$refs[`layer_${id}`];
                if (img) {
                    img.style.display = 'none';
                }
                this.$emit('imgNotFound', id);
            }
        }
    };
</script>
